import Vue from 'vue';
import VueRouter from 'vue-router';
import visualization from './components/visualization.vue';

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    base: '/bacteroides/',//process.env.BASE_URL,
    routes: [
    {
        path: '/bacteroides/', 
        component: visualization,
        props(route) {
          return {  myprop: route.query.config }
        }
      }
  ],
});
